module.exports = __webpack_public_path__ + "static/img/product_default.2dc144ad.png";